import React from 'react'
import styled from 'styled-components'

const DialogSectionTitle = styled.div`
  color: #009688;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 6px;
`
export default DialogSectionTitle